import { c as _c } from "react/compiler-runtime";
import { ContentSummary as CommonContentSummary, ContentSummaryProps } from "common/components/ContentSummary";
import { ContentSummaryBlock } from "common/types/graphql";
export type ContentSummaryFrontendBlock = ContentSummaryProps & Omit<ContentSummaryBlock, "image">;
export const ContentSummary = props => {
  "use memo";

  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <CommonContentSummary {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};